import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { Download, History, Loader2, Send } from 'lucide-react';
import { fmtEur } from '../paiementsCb/gedUtils';
import { API, downloadBlob } from './api';
import { RenvoiDialog } from './RenvoiDialog';
import { ArchiveAnnuelle } from './ArchiveAnnuelle';

const ORIGINE = { automatique: 'Envoi automatique', renvoi: 'Renvoi manuel' };
const fmtDT = (iso) => (iso ? new Date(iso).toLocaleString('fr-FR', { dateStyle: 'short', timeStyle: 'short' }) : '—');

const Ligne = ({ x, headers, canResend, onResend }) => (
  <tr className="border-t border-slate-100 align-top" data-testid={`export-row-${x.id}`}>
    <td className="py-2 pr-3 font-semibold text-slate-900">{x.mois}</td>
    <td className="py-2 pr-3 text-slate-600">{fmtDT(x.at)}<div className="text-[11px] text-slate-400">{ORIGINE[x.origine] || x.origine}{x.par ? ` · ${x.par}` : ''}</div></td>
    <td className="py-2 pr-3 text-xs text-slate-600" data-testid={`export-dest-${x.id}`}>{(x.destinataires || []).join(', ')}</td>
    <td className="py-2 pr-3 text-right tabular-nums">{x.nb_cb ?? '—'} · {fmtEur(x.total_cb)}</td>
    <td className="py-2 pr-3 text-right tabular-nums">{x.nb_sepa ?? '—'} · {fmtEur(x.total_sepa)}</td>
    <td className="py-2 pr-3 text-right font-semibold tabular-nums" data-testid={`export-total-${x.id}`}>{fmtEur(x.total)}</td>
    <td className="py-2 pr-3">
      <span className={`text-[10px] font-semibold px-2 py-0.5 rounded-full ${x.envoye ? 'bg-emerald-100 text-emerald-800' : 'bg-red-100 text-red-700'}`}>{x.envoye ? 'Envoyé' : 'Échec'}</span>
    </td>
    <td className="py-2 whitespace-nowrap text-right">
      <button type="button" onClick={() => downloadBlob(`/comptabilite/exports/${x.mois}/xlsx`, headers, `export_comptable_${x.mois}.xlsx`)} data-testid={`export-download-${x.id}`}
        className="inline-flex items-center gap-1 text-xs px-2 py-1 rounded-md border border-slate-200 hover:bg-slate-50"><Download className="h-3 w-3" /> Excel</button>
      {canResend && (
        <button type="button" onClick={() => onResend(x)} data-testid={`export-resend-${x.id}`}
          className="ml-1 inline-flex items-center gap-1 text-xs px-2 py-1 rounded-md bg-[#0a3d62] text-white hover:bg-[#0c4a75]"><Send className="h-3 w-3" /> Renvoyer</button>
      )}
    </td>
  </tr>
);

export const HistoriqueExports = ({ headers, canResend = false }) => {
  const [items, setItems] = useState(null);
  const [renvoi, setRenvoi] = useState(null);
  const load = useCallback(() => {
    axios.get(`${API}/comptabilite/exports`, { headers }).then((r) => setItems(r.data.items)).catch(() => setItems([]));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, [load]);
  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-4 space-y-3" data-testid="historique-exports">
      <h3 className="flex items-center gap-2 font-bold text-slate-900"><History className="h-5 w-5 text-[#0a3d62]" /> Historique des exports comptables</h3>
      <ArchiveAnnuelle headers={headers} />
      {!items ? <Loader2 className="h-5 w-5 animate-spin text-slate-400" /> : items.length === 0
        ? <p className="text-sm text-slate-500 py-4" data-testid="historique-exports-empty">Aucun export envoyé pour le moment.</p> : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead><tr className="text-left text-[11px] uppercase tracking-wide text-slate-500">
                <th className="pb-2">Mois</th><th className="pb-2">Envoyé le</th><th className="pb-2">Destinataires</th>
                <th className="pb-2 text-right">CB</th><th className="pb-2 text-right">SEPA</th><th className="pb-2 text-right">Total</th><th className="pb-2">Statut</th><th />
              </tr></thead>
              <tbody>{items.map((x) => <Ligne key={x.id} x={x} headers={headers} canResend={canResend} onResend={setRenvoi} />)}</tbody>
            </table>
          </div>
        )}
      {renvoi && <RenvoiDialog exp={renvoi} headers={headers} onClose={() => setRenvoi(null)} onDone={() => { setRenvoi(null); load(); }} />}
    </section>
  );
};
